import React from 'react';
import IHome from '../interfaces/IHome';

import Config from '../utils/Config';
import Translate from '../utils/Translate';
import styles from './HomeCard.scss';
import FavouriteIcon from './FavouriteIcon';
import searchApi from '../utils/searchApi';
import withUserHOC, { IUserState } from '../stores/withUser';
import placeholderImg from '../assets/img/placeholder.png';
import ButtonRound from './ButtonRound';
import Icon from "./MaterialUi/Icon";
import { alert, modal } from "./AsyncModal";
import LocationMap from './SearchResult/LocationMap';
import { SvgIconComponent } from '@mui/icons-material';
import HomeFinancialFeasibility from './UserPage/SearchCockpit/HomeFinancialFeasibility';
import { IFinancialFeasibility } from '../utils/JsonApiRequest';
import Button from './MaterialUi/Button';
// import OffMarketSvg from '../assets/img/off_market.svg';

const OffMarketSvg = React.lazy<SvgIconComponent>(() => import(/* webpackChunkName: "search" */ '../assets/img/off_market.svg'));


const baseUrl = Config.get('baseUrl');
const placeholder = '-';

export interface IHomeCardProps {
    data: IHome;
    isActive?: boolean;
    isVisible?: boolean;
    className?: string;
    showFavourite?: boolean;
    showFinancialFeasibility?: boolean;

    user: IUserState;
    browserAffiliate: string;
}

export interface IHomeCardState { }
class HomeCard extends React.Component<IHomeCardProps, IHomeCardState> {
    render() {
        const home = this.props.data;
        const showFavourite = this.props.showFavourite !== false;

        const { isActive, user, browserAffiliate } = this.props;

        const isVisible = this.props.isVisible !== false;

        // const imgSrc = home.offMarket ? (user.isPremium ? baseUrl + home?.image?.path : baseUrl + '/img/off_market.svg') : baseUrl + home?.image?.path;

        // build text for type and location
        let typeAndLocationText = `${home.propertyTypeText ? home.propertyTypeText : home.propertyType || ''} ${home.propertyTypeText && home.propertyType ? ' in ' : ''
        } ${home.locality || ''}${home.sublocality_level_2 && home.locality != home.sublocality_level_2 ? ' (' + home.sublocality_level_2 + ')' : ''}${!home.sublocality_level_2 && home.sublocality ? ' (' + home.sublocality + ')' : ''}`;

        // temp unicode fix for import issue in WGLDE-1951
        // TODO: remove end of 2023
        typeAndLocationText = typeAndLocationText
            .replaceAll("Ã¼", 'ü')
            .replaceAll("Ã£", 'ä')
            .replaceAll("Ãµ", 'ö')
            .replaceAll("ÃŸ", 'ß');

        const detailUrl = baseUrl + '/property/' + home.id;

        const isAffiliate = home.affiliates.includes(browserAffiliate ? browserAffiliate : user.affiliateName);

        const handleShowMap = (ev: React.SyntheticEvent) => {
            ev.preventDefault();
            modal(<LocationMap latLng={home} />, { title: typeAndLocationText, maxWidth: 'lg' })
                .then(() => {
                // close modal
                })
                .catch((e) => {
                // close modal
                });
        }

        return (
            <div className={styles.homeCardOld + ' property z-depth-1 ' + (isActive ? styles.active : '')} id={'homeCard' + home.id}>
                
                <div className={styles.propertyImage}>
                    {/* {showFavourite && <FavouriteIcon id={home.id} className={styles.favourite} />} */}

                    <div className={styles.image}>
                        {home.image.path && isVisible ? (
                            home.offMarket ? (
                                <React.Suspense fallback={<div />}><OffMarketSvg width="480" height="270" /></React.Suspense>
                            ) : (
                                <img src={baseUrl + home.image.path} alt={''} width="480" height="270" />
                            )
                        ) : (
                            <img src={placeholderImg} width="480" height="270" />
                        )}
                    </div>
                    {home.exclusive && (
                        <div className={styles.propertyMarker}>
                            <span />
                            <div className={styles.exclusive}>Exklusive Immobilie</div>
                        </div>
                    )}
                    {home.offMarket && (
                        <div className={styles.propertyMarker}>
                            <div className="marker marker--small marker--off-market">
                                <div className="marker__text">off-market</div>
                            </div>
                        </div>
                    )}
                    {home.foreclosure && (
                        <div className={styles.propertyMarker}>
                            <span />
                            <div className={styles.forcedSale}>Zwangsversteigerung</div>
                        </div>
                    )}
                    {isAffiliate && (
                        <div className={styles.propertyMarker}>
                            <span />
                            <div className={styles.affiliate}>Dein Wohnglück-Partner</div>
                        </div>
                    )}
                </div>

                <div className={styles.propertyContent + ' property__content'}>
                    <div className={styles.title}>
                        <a href={detailUrl}>{typeAndLocationText}</a>
                        {this.props.showFinancialFeasibility && <HomeFinancialFeasibility customerUuid={user.id} advisorUuid={null} propertyId={home.id} source={null}/>}
                    </div>
                    <div className={styles.valueContainer}>
                        <div className={styles.data}>
                            <div className={styles.entry}>
                                {!home.priceOnDemand && <div className={styles.value}>{home.price ? Translate.getNumber(home.price) + ' €' : '-'}</div>}
                                {home.priceOnDemand && <div className={styles.value}>Auf Anfrage</div>}
                            </div>
                            {(home.propertyType === 'apartment' || home.propertyType === 'house') ?
                                <div className={styles.entry}>
                                        <div className={styles.value}>
                                        {home.livingArea ? Translate.getNumber(home.livingArea) + ' m²' : placeholder}
                                    </div>
                                    </div>
                                : home.livingArea ?
                                    <div className={styles.entry}>
                                            <div className={styles.value}>{home.livingArea ? Translate.getNumber(home.livingArea) + ' m²' : '-'}</div>
                                        </div>
                                    : home.totalArea ?
                                        <div className={styles.entry}>
                                                <div className={styles.value}>{home.totalArea ? Translate.getNumber(home.totalArea) + ' m²' : '-'}</div>
                                            </div>
                                        : home.usefulArea ?
                                            <div className={styles.entry}>
                                                    <div className={styles.value}>
                                                    {home.usefulArea ? Translate.getNumber(home.usefulArea) + ' m²' : placeholder}
                                                </div>
                                                </div>
                                            : home.plotArea ?
                                                <div className={styles.entry}>
                                                        <div className={styles.value}>
                                                        {home.plotArea ? Translate.getNumber(home.plotArea) + ' m²' : placeholder}
                                                    </div>
                                                    </div> : null
                            }

                            {(home.chambers || (home.propertyType === 'apartment' || home.propertyType === 'house')) &&
                            <div className={styles.entry}>
                                <div className={styles.value}>
                                    {home.chambers ? Translate.getNumber(home.chambers) + ' Zi.' : placeholder}
                                </div>
                            </div>}

                            {home.floor > 0 &&
                            <div className={styles.entry}>
                                <div className={styles.value}>
                                    {home.floor ? Translate.getNumber(home.floor) + '. OG' : placeholder}
                                </div>
                            </div>}

                            {home.floor === 0 && <div className={styles.entry} title="Erdgeschoss">
                                <div className={styles.value}>
                                    Erdg.
                                </div>
                            </div>}

                        </div>
                        <div className={styles.location}>
                            <div className={styles.address}>
                                {home.locationText}
                            </div>
                            <div className={styles.map}>
                                <ButtonRound icon={<Icon name="map" />} onClick={handleShowMap} variant="outlinedEdge" color="grey" size="small" >Karte</ButtonRound>
                                {/* <Button startIcon={<Icon name="map" />} onClick={handleShowMap} variant="outlined" color="inherit" size="small" >Karte</Button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    protected handleHomeClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
        ev.preventDefault();
        searchApi.setActive(this.props.data.id);
        location.href = ev.currentTarget.href;
    };
}

export default withUserHOC(HomeCard);
